// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-analysis-section{
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px; /* Space between sections */
}

.analysis-selection{
  display: flex;
  flex-direction: column;
  width: 100%;
}
/* Ensure inner content wrapper spans full width so top rows can center */
.analysis-content-wrapper {
  width: 100%;
}

.analysis-tables{
  display: flex;
}

/* Feature stage row spacing to align with .analysis-category margins */
.feature-stage-row {
  margin: 10px 40px 14px 40px;
  
}

.analysis-category {
  margin: 20px 40px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.analysis-category h4 {
  background-color: #cfe2f3;
  padding: 10px;
  text-align: center;
  margin: 0 -10px 10px;
  border-radius: 5px 5px 0 0;
}

.analysis-category table {
  border-bottom: 1px solid #ddd;
}

.analysis-selection table {
  width: 100%;
  margin-right: 20px;
  border-collapse: collapse;
}

.analysis-selection td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: center;
  cursor: pointer;
}

.analysis-selection tr.selected {
  background-color: #6495ed;
  color: white;
}

.analysis-selection button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.analysis-selection button:hover {
  background-color: #a04545;
}

.analysis-button {
  margin-top: 20px;
  text-align: center;
}

/* Parameter Settings Styles */
.parameter-settings {
  margin: 20px 40px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  background-color: #f9f9f9;
  width: calc(100% - 80px);
}

.parameter-settings h4 {
  background-color: #e2f3cf;
  padding: 10px;
  text-align: center;
  margin: -20px -20px 20px;
  border-radius: 5px 5px 0 0;
}

.selected-method-info {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
}

.param-container {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
}

.param-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.param-row {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
}

.param-label {
  width: 300px;
  padding: 5px;
  font-weight: bold;
  color: #555;
  position: relative;
  cursor: help;
}

.param-label:hover .param-tooltip {
  visibility: visible;
  opacity: 1;
}

/* Parameter tooltip styles */
.param-tooltip {
  visibility: hidden;
  width: 280px;
  background-color: #2c3e50;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 0;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
  font-weight: normal;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 4px 14px rgba(0,0,0,0.15);
}

.param-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 25%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #2c3e50 transparent transparent transparent;
}

.param-input {
  flex: 1 1;
}

.param-input select {
  width: 90%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.param-input select.required-param-missing {
  border-color: #d9534f;
  box-shadow: 0 0 0 1px rgba(217, 83, 79, 0.2);
}

.param-input.required-param-missing-border .searchable-column-list-container {
  border: 1px solid #d9534f;
  border-radius: 6px;
  padding: 4px;
  box-shadow: 0 0 0 1px rgba(217, 83, 79, 0.2);
}

.survival-column-row .param-input .searchable-column-list-container {
  margin-top: 4px;
  margin-bottom: 0;
  max-width: 16%;
}

.survival-validation-error {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #e3bcbc;
  border-radius: 4px;
  background-color: #fff6f6;
  color: #a94442;
  font-size: 14px;
  font-weight: 600;
}

.param-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.default-param-option {
  margin-bottom: 20px;
  text-align: center;
}

.default-param-option button {
  padding: 8px 15px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: static;
}

.default-param-option button:hover {
  background-color: #5a6268;
}

.param-update-button {
  text-align: center;
  margin-top: 15px;
}

.param-update-button button {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: static;
}

.param-update-button button:hover {
  background-color: #0069d9;
}`, "",{"version":3,"sources":["webpack://./src/css/step5-selectAnalysis.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ,EAAE,2BAA2B;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,yEAAyE;AACzE;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,2BAA2B;;AAE7B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".select-analysis-section{\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px; /* Space between sections */\n}\n\n.analysis-selection{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n/* Ensure inner content wrapper spans full width so top rows can center */\n.analysis-content-wrapper {\n  width: 100%;\n}\n\n.analysis-tables{\n  display: flex;\n}\n\n/* Feature stage row spacing to align with .analysis-category margins */\n.feature-stage-row {\n  margin: 10px 40px 14px 40px;\n  \n}\n\n.analysis-category {\n  margin: 20px 40px;\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n}\n\n.analysis-category h4 {\n  background-color: #cfe2f3;\n  padding: 10px;\n  text-align: center;\n  margin: 0 -10px 10px;\n  border-radius: 5px 5px 0 0;\n}\n\n.analysis-category table {\n  border-bottom: 1px solid #ddd;\n}\n\n.analysis-selection table {\n  width: 100%;\n  margin-right: 20px;\n  border-collapse: collapse;\n}\n\n.analysis-selection td {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: center;\n  cursor: pointer;\n}\n\n.analysis-selection tr.selected {\n  background-color: #6495ed;\n  color: white;\n}\n\n.analysis-selection button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.analysis-selection button:hover {\n  background-color: #a04545;\n}\n\n.analysis-button {\n  margin-top: 20px;\n  text-align: center;\n}\n\n/* Parameter Settings Styles */\n.parameter-settings {\n  margin: 20px 40px;\n  border: 1px solid #ccc;\n  padding: 20px;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  width: calc(100% - 80px);\n}\n\n.parameter-settings h4 {\n  background-color: #e2f3cf;\n  padding: 10px;\n  text-align: center;\n  margin: -20px -20px 20px;\n  border-radius: 5px 5px 0 0;\n}\n\n.selected-method-info {\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 15px;\n  padding: 10px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n}\n\n.param-container {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 15px;\n  margin-bottom: 15px;\n}\n\n.param-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.param-row {\n  display: flex;\n  margin-bottom: 8px;\n  align-items: center;\n}\n\n.param-label {\n  width: 300px;\n  padding: 5px;\n  font-weight: bold;\n  color: #555;\n  position: relative;\n  cursor: help;\n}\n\n.param-label:hover .param-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Parameter tooltip styles */\n.param-tooltip {\n  visibility: hidden;\n  width: 280px;\n  background-color: #2c3e50;\n  color: #fff;\n  text-align: left;\n  border-radius: 6px;\n  padding: 8px 12px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 0;\n  margin-left: -60px;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow: 0 4px 14px rgba(0,0,0,0.15);\n}\n\n.param-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 25%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #2c3e50 transparent transparent transparent;\n}\n\n.param-input {\n  flex: 1;\n}\n\n.param-input select {\n  width: 90%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.param-input select.required-param-missing {\n  border-color: #d9534f;\n  box-shadow: 0 0 0 1px rgba(217, 83, 79, 0.2);\n}\n\n.param-input.required-param-missing-border .searchable-column-list-container {\n  border: 1px solid #d9534f;\n  border-radius: 6px;\n  padding: 4px;\n  box-shadow: 0 0 0 1px rgba(217, 83, 79, 0.2);\n}\n\n.survival-column-row .param-input .searchable-column-list-container {\n  margin-top: 4px;\n  margin-bottom: 0;\n  max-width: 16%;\n}\n\n.survival-validation-error {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e3bcbc;\n  border-radius: 4px;\n  background-color: #fff6f6;\n  color: #a94442;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.param-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.default-param-option {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.default-param-option button {\n  padding: 8px 15px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 0;\n  position: static;\n}\n\n.default-param-option button:hover {\n  background-color: #5a6268;\n}\n\n.param-update-button {\n  text-align: center;\n  margin-top: 15px;\n}\n\n.param-update-button button {\n  padding: 8px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 0;\n  position: static;\n}\n\n.param-update-button button:hover {\n  background-color: #0069d9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
